import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import { PaymentMethod } from '../../models/payment-method.model';

const selectPaymentMethodsState = createSelector(
  selectDashboardState,
  (dashboardState) => dashboardState.paymentMethods
);

export const selectPaymentMethods = createSelector(
  selectPaymentMethodsState,
  (paymentMethodsState) => paymentMethodsState.paymentMethods
);

export const selectIsLoadingPaymentMethods = createSelector(
  selectPaymentMethodsState,
  (paymentMethodsState) => paymentMethodsState.isLoadingPaymentMethods
);

export const selectDefaultPaymentMethod = createSelector(
  selectPaymentMethods,
  (paymentMethods) => {
    const defaultPaymentMethod = paymentMethods.find((pm: PaymentMethod) => pm.default);
    return !!defaultPaymentMethod ? defaultPaymentMethod : null;
  }
);

export const selectIsLoadingPostPaymentMethod = createSelector(
  selectPaymentMethodsState,
  (paymentMethodsState) => paymentMethodsState.isLoadingPostPaymentMethod
);

export const selectLoadingDeletePaymentMethod = createSelector(
  selectPaymentMethodsState,
  (paymentMethodsState) => paymentMethodsState.isLoadingDeletePaymentMethod
);
